export default function runAfterFramePaint(callback) {
    /* istanbul ignore next */
    requestAnimationFrame(() => {
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = callback;
        messageChannel.port2.postMessage(undefined);
    });
}
export const isMobile = window.innerWidth <= 600; // 'sm' 
export const isDesktop = window.innerWidth > 600; // 'sm' 
export const isIOS = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
export const isIntegrated = !!localStorage.getItem('integrated');
export const isApple = /Macintosh/.test(navigator.userAgent) || /iOS/.test(navigator.userAgent);
//@ts-ignore
export const isIOSWPA = window.navigator.standalone;
